module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/10ft-6fab84f5882de6813e518d1ddaeb5598.png";